import { AppBox, AppTypography } from 'components'
import { FC } from 'react'

interface Props {}

export const PauseMembershipConfimation: FC<Props> = () => {
  return (
    <AppBox>
      <AppTypography fontSize={32} fontWeight={700} textAlign={'center'}>
        Your subscription plan is scheduled to pause on {}
      </AppTypography>
      <AppBox paddingX={2} paddingTop={2} display={'flex'} justifyContent={'space-between'} gap={10}>
        <AppBox>
          <AppTypography fontSize={16} fontWeight={'bold'}>
            Resuming your subscription
          </AppTypography>
          <AppTypography color={'grey.500'} fontSize={14}>
            We understand everyone needs a break from time to time. Just know you can choose to resume your subscription
            plan early anytime in the future. Simply go to your Billing & Plans. When you choose the Change Plan option
            we’ll supply a Resume button the next time.
          </AppTypography>
        </AppBox>
        <AppBox>
          <img src="/images/pax/Confirmation.png" alt="img" />
        </AppBox>
      </AppBox>
    </AppBox>
  )
}
